/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from "../auth/hooks/use-auth";
import { useUser } from "../auth/hooks/use-user";
import { useControlledEffect } from "./use-controlled-effect";

const key = "6LeADlssAAAAAH0mAA3GSKAsHkP-tAvM0cxoe0la";

export const getCaptchaToken = async (action: string): Promise<string> => {
  const grecaptcha = (window as any)?.grecaptcha?.enterprise;
  return grecaptcha
    ? action +
        ":" +
        (await grecaptcha.execute(key, {
          action,
        }))
    : "";
};

let didInitRecaptcha = false;

export const useGReCaptcha = () => {
  const { isInitializing } = useAuth();
  const { data: user } = useUser();
  useControlledEffect(() => {
    if (isInitializing) return;
    if (!user?.id) {
      if (didInitRecaptcha) return;
      didInitRecaptcha = true;
      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/enterprise.js?render=" + key;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [user?.id, isInitializing]);
};
